export const GET_PROFILE_DETAILS = "GET_PROFILE_DETAILS";
export const GET_PROFILE_DETAILS_INIT = "GET_PROFILE_DETAILS_INIT";
export const GET_PROFILE_DETAILS_SUCCESS = "GET_PROFILE_DETAILS_SUCCESS";
export const GET_PROFILE_DETAILS_FAILED = "GET_PROFILE_DETAILS_FAILED";

export const GET_ALLOCATOR_Strategy = "GET_ALLOCATOR_Strategy";
export const GET_ALLOCATOR_Strategy_INIT = "GET_ALLOCATOR_Strategy_INIT";
export const GET_ALLOCATOR_Strategy_SUCCESS = "GET_ALLOCATOR_Strategy_SUCCESS";
export const GET_ALLOCATOR_Strategy_FAILED = "GET_ALLOCATOR_Strategy_FAILED";

export const UPDATE_ALLOCATOR_STRATEGY = "UPDATE_ALLOCATOR_STRATEGY";
export const UPDATE_ALLOCATOR_STRATEGY_INIT = "UPDATE_ALLOCATOR_STRATEGY_INIT";
export const UPDATE_ALLOCATOR_STRATEGY_SUCCESS = "UPDATE_ALLOCATOR_STRATEGY_SUCCESS";
export const UPDATE_ALLOCATOR_STRATEGY_FAILED = "UPDATE_ALLOCATOR_STRATEGY_FAILED";

export const GET_STRATEGY = 'GET_STRATEGY';
export const GET_STRATEGY_INIT = 'GET_STRATEGY_INIT';
export const GET_STRATEGY_SUCCESS = 'GET_STRATEGY_SUCCESS';
export const GET_STRATEGY_FAILED = 'GET_STRATEGY_FAILED';

export const GET_ALL_INVESTOR = 'GET_ALL_INVESTOR';
export const GET_ALL_INVESTOR_INIT = 'GET_ALL_INVESTOR_INIT';
export const GET_ALL_INVESTOR_SUCCESS = 'GET_ALL_INVESTOR_SUCCESS';
export const GET_ALL_INVESTOR_FAILED = 'GET_ALL_INVESTOR_FAILED';

export const UPDATE_TENET_DETIALS = 'UPDATE_TENET_DETIALS';
export const UPDATE_TENET_DETIALS_INIT = 'UPDATE_TENET_DETIALS_INIT';
export const UPDATE_TENET_DETIALS_SUCCESS = 'UPDATE_TENET_DETIALS_SUCCESS';
export const UPDATE_TENET_DETIALS_FAILED = 'UPDATE_TENET_DETIALS_FAILED';

export const UPDATE_COVERIMAGE = 'UPDATE_COVERIMAGE';
export const UPDATE_COVERIMAGE_INIT = 'UPDATE_COVERIMAGE_INIT';
export const UPDATE_COVERIMAGE_SUCCESS = 'UPDATE_COVERIMAGE_SUCCESS';
export const UPDATE_COVERIMAGE_FAILED = 'UPDATE_COVERIMAGE_FAILED';

export const UPDATE_COMPANYLOGO = 'UPDATE_COMPANYLOGO';
export const UPDATE_COMPANYLOGO_INIT = 'UPDATE_COMPANYLOGO_INIT';
export const UPDATE_COMPANYLOGO_SUCCESS = 'UPDATE_COMPANYLOGO_SUCCESS';
export const UPDATE_COMPANYLOGO_FAILED = 'UPDATE_COMPANYLOGO_FAILED';

export const GET_COMPANY_POST_FEED = 'GET_COMPANY_POST_FEED';
export const GET_COMPANY_POST_FEED_INIT = 'GET_COMPANY_POST_FEED_INIT';
export const GET_COMPANY_POST_FEED_SUCCESS = 'GET_COMPANY_POST_FEED_SUCCESS';
export const GET_COMPANY_POST_FEED_FAILED = 'GET_COMPANY_POST_FEED_FAILED';

export const GET_COMPANY_USERS = 'GET_COMPANY_USERS';
export const GET_COMPANY_USERS_INIT = 'GET_COMPANY_USERS_INIT';
export const GET_COMPANY_USERS_SUCCESS = 'GET_COMPANY_USERS_SUCCESS';
export const GET_COMPANY_USERS_FAILED = 'GET_COMPANY_USERS_FAILED';

export const GET_FUND_SPOTLIGHTS = 'PROFILE@GET_FUND_SPOTLIGHTS';
export const GET_FUND_SPOTLIGHTS_INIT = 'PROFILE@GET_FUND_SPOTLIGHTS_INIT';
export const GET_FUND_SPOTLIGHTS_SUCCESS = 'PROFILE@GET_FUND_SPOTLIGHTS_SUCCESS';
export const GET_FUND_SPOTLIGHTS_FAILED = 'PROFILE@GET_FUND_SPOTLIGHTS_FAILED';

export const CREATE_ALLOCATOR_INFO = 'CREATE_ALLOCATOR_INFO';
export const CREATE_ALLOCATOR_INFO_INIT = 'CREATE_ALLOCATOR_INFO_INIT';
export const CREATE_ALLOCATOR_INFO_SUCCESS = 'CREATE_ALLOCATOR_INFO_SUCCESS';
export const CREATE_ALLOCATOR_INFO_FAILED = 'CREATE_ALLOCATOR_INFO_FAILED';

export const UPDATE_ALLOCATOR_INFO = 'UPDATE_ALLOCATOR_INFO';
export const UPDATE_ALLOCATOR_INFO_INIT = 'UPDATE_ALLOCATOR_INFO_INIT';
export const UPDATE_ALLOCATOR_INFO_SUCCESS = 'UPDATE_ALLOCATOR_INFO_SUCCESS';
export const UPDATE_ALLOCATOR_INFO_FAILED = 'UPDATE_ALLOCATOR_INFO_FAILED';

export const GET_ALLOCATOR_INFO = 'GET_ALLOCATOR_INFO';
export const GET_ALLOCATOR_INFO_INIT = 'GET_ALLOCATOR_INFO_INIT';
export const GET_ALLOCATOR_INFO_SUCCESS = 'GET_ALLOCATOR_INFO_SUCCESS';
export const GET_ALLOCATOR_INFO_FAILED = 'GET_ALLOCATOR_INFO_FAILED';

export const UPDATE_NDE = 'UPDATE_NDE';
export const UPDATE_NDE_INIT = 'UPDATE_NDE_INIT';
export const UPDATE_NDE_SUCCESS = 'UPDATE_NDE_SUCCESS';
export const UPDATE_NDE_FAILED = 'UPDATE_NDE_FAILED';

export const UPDATE_FSI = 'UPDATE_FSI';
export const UPDATE_FSI_INIT = 'UPDATE_FSI_INIT';
export const UPDATE_FSI_SUCCESS = 'UPDATE_FSI_SUCCESS';
export const UPDATE_FSI_FAILED = 'UPDATE_FSI_FAILED';

export const UPDATE_IDP = 'UPDATE_IDP';
export const UPDATE_IDP_INIT = 'UPDATE_IDP_INIT';
export const UPDATE_IDP_SUCCESS = 'UPDATE_IDP_SUCCESS';
export const UPDATE_IDP_FAILED = 'UPDATE_IDP_FAILED';

export const UPDATE_IC = 'UPDATE_IC';
export const UPDATE_IC_INIT = 'UPDATE_IC_INIT';
export const UPDATE_IC_SUCCESS = 'UPDATE_IC_SUCCESS';
export const UPDATE_IC_FAILED = 'UPDATE_IC_FAILED';